import React, { Component } from 'react';
import Volume from './Volume';
import { observer } from 'mobx-react';
import './MediaCtrList.css';

import { DataStore } from '../DataStore';

@observer
class MediaCtrList extends Component {

    onClickListIcon = (event) => {
        DataStore.showPlayList = !DataStore.showPlayList;
    }

    render() {
        return (
            <div className="media-ctr-list-box">
                <div className="icon-ctr">
                    <div className="icon-item">
                        <button className={"iconfont icon-" + (DataStore.showPlayList ? 'fullscreen' : 'list')}
                            onClick={this.onClickListIcon}></button>
                    </div>
                </div>
                <div className="volume-ctr">
                    <Volume />
                </div>
            </div>
        );
    }
}

export default MediaCtrList;


// WEBPACK FOOTER //
// ./src/components/MediaCtrList.js